<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <el-row v-else>
    <el-row class="m-t-20 m-b-20 p-40 block">
      <el-col :span="16" :offset="4">
        <el-row type="flex" justify="center">
          <h1>{{detail.title}}</h1>
        </el-row>
        <el-row class="m-b-40" type="flex" justify="center">
          <span class="m-r-20">{{detail.department}}</span>
          <span>发布于 {{detail.pubdate}}</span>
        </el-row>
        <el-row class="m-b-40" type="flex" justify="center">
          <p class="text-pre-wrap l-h-2" style="text-indent: 2em">{{detail.content}}</p>
        </el-row>
        <template v-if="detail.attachment.length">
          <el-row type="flex">
            <span class="text-pre-wrap">附件：</span>
          </el-row>
          <el-row v-for="link in detail.attachment" :key="link.name" type="flex">
            <a :href="link.url" download target="_blank">{{link.name}}</a>
          </el-row>
        </template>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="default" size="cons" @click="goBack">返回</el-button>
    </el-row>
  </el-row>
</template>

<script>
import * as Home from 'api/home'

export default {
  data () {
    return {
      ready: false,
      detail: null,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        this.detail = await Home.get_notice_detail(this.$query.notice_uid)
        this.status = status
        this.ready = true
      })
    },
    goBack () {
      if (this.$query.pre_page !== undefined) {
        this.$router.push(this.$location.notice_list({
          search: this.$query.search,
          current: this.$query.current,
        }, false))
      } else {
        this.$router.go(-1)
      }
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
.flex-box {
  display: flex;
  &.column {
    align-items: flex-start;
    flex-direction: column;
  }
  &.row {
    align-items: center;
    flex-direction: row;
  }
}

.block {
  background: white;
  padding: 0 20px 20px 20px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/NoticeDetail.vue